"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.protobufMapper = exports.buildRoomInviteData = void 0;
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const toolbox_1 = require("@streem/toolbox");
const domain_id_1 = require("@streem/domain-id");
function buildRoomInviteData({ sid, roomSid, status, fromUserSid, fromDeviceSid, toUserSid, toDeviceSid, }, user) {
    (0, toolbox_1.invariant)(sid &&
        roomSid &&
        roomSid &&
        status &&
        fromUserSid &&
        fromDeviceSid &&
        toUserSid &&
        toDeviceSid, 'Received malformed RoomInvitation from API');
    return {
        id: new domain_id_1.RoomInvitationId(sid),
        roomId: new domain_id_1.RoomId(roomSid),
        status: exports.protobufMapper.roomInvitationStatusFromV1(streem_sdk_protobuf_1.streem.api.RoomInvitation.Status[status]),
        fromUserId: new domain_id_1.UserId(fromUserSid),
        fromUser: user,
        fromDeviceId: new domain_id_1.DeviceId(fromDeviceSid),
        toUserId: new domain_id_1.UserId(toUserSid),
        toDeviceId: new domain_id_1.DeviceId(toDeviceSid),
    };
}
exports.buildRoomInviteData = buildRoomInviteData;
// Until we have the protobuf stuff for JS figured out, we are simply mapping
// the V1 protobuf world to the current typescript world... -SA
exports.protobufMapper = {
    roomInvitationStatusToV1: (status) => {
        if (status == 'UNKNOWN' || status == 'UNRECOGNIZED') {
            return 'STATUS_INVALID';
        }
        return `STATUS_${status}`;
    },
    roomInvitationStatusFromV1: (status) => {
        if (!status || status == 'STATUS_INVALID') {
            return 'UNKNOWN';
        }
        return status.substring('STATUS_'.length);
    },
};
//# sourceMappingURL=build_room_invitation.js.map